/**
 * Extract a single display string from a localized JSONB value
 * (`{ en: '…', fr: '…', … }`). Falls back to the `en` entry, then to an
 * empty string. Shared by the shop pages and the article card so the
 * locale-extraction logic lives in exactly one place.
 */
export function getLocalizedText(value: unknown, locale = 'en'): string {
  if (!value || typeof value !== 'object') return '';
  const map = value as Record<string, string>;
  return map[locale] ?? map['en'] ?? '';
}
